import type { RouteObject } from "react-router-dom";
import { Layout } from "./Layout";
import { dashboardChildRoutes } from "./tabList";
import type { environments } from "@dealer-center/core-enviroment";

export const dashboardRoute = (enviroment: environments): RouteObject => {
  return {
    path: "dashboard/*",
    element: <Layout />,
    children: dashboardChildRoutes(enviroment)
  };
};
